import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520e92de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ProgressBar-status-text-pos"
}
const _hoisted_2 = {
  key: 2,
  class: "ProgressBar-status-text-pos"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PVProgressBar = _resolveComponent("PVProgressBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PVProgressBar, {
          key: 0,
          class: "ProgressBar_progressBar",
          value: _ctx.progress
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.longerThanUsual && _ctx.longerThanUsualStatusText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.longerThanUsualStatusText), 1))
      : (_ctx.loading && _ctx.loadingStatusText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.loadingStatusText), 1))
        : _createCommentVNode("", true)
  ]))
}